import _ from 'lodash';
import { FormField, Textarea } from 'pages/publications_v2/helpers/FieldHelper';
import Dropzone from 'react-dropzone';
import { XMLParser } from 'fast-xml-parser';
import { useFormikContext } from 'formik';
import HelperFunctions from 'pages/global/HelperFunctions';

export function Saml({ isEditMode = false }) {
    const { setFieldValue, validateForm } = useFormikContext();

    return (
        <>
            <FormField
                name="entityId"
                label="Application (entity) ID"
                props={{
                    disabled: isEditMode,
                    autoComplete: 'off',
                    'data-1p-ignore': '',
                    required: true,
                }}
            />

            {!isEditMode && (
                <Dropzone maxFiles={1} accept={{ 'text/xml': ['.xml'] }} onDrop={handleDrop}>
                    {({ getRootProps, getInputProps }) => (
                        <div {...getRootProps({ style })}>
                            <input {...getInputProps()} />
                            <div className="text-muted font-small-weighted pr-2">
                                Upload een Azure SAML metadata XML om de gegevens automatisch in te vullen.
                            </div>
                        </div>
                    )}
                </Dropzone>
            )}

            <FormField
                name="signInUrl"
                label="Sign In url"
                props={{
                    disabled: isEditMode,
                    autoComplete: 'off',
                    'data-1p-ignore': '',
                    required: true,
                }}
            />
            <FormField
                name="logoutUrl"
                label="Logout url"
                props={{
                    disabled: isEditMode,
                    autoComplete: 'off',
                    'data-1p-ignore': '',
                    required: true,
                }}
            />
            <Textarea
                name="cert"
                label="Certificate"
                props={{
                    disabled: isEditMode,
                    autoComplete: 'off',
                    'data-1p-ignore': '',
                    required: true,
                    rows: 5,
                }}
            />
        </>
    );

    function handleDrop(acceptedFiles) {
        if (acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            const reader = new FileReader();

            reader.onload = (e) => {
                const data = e.target.result;

                const parser = new XMLParser({
                    ignoreAttributes: false,
                    attributeNamePrefix: '',
                });
                const xmlObject = parser.parse(data);

                if (xmlObject && xmlObject.hasOwnProperty('EntityDescriptor')) {
                    const entityId = _.get(xmlObject, ['EntityDescriptor', 'entityID']);

                    if (entityId) {
                        setFieldValue('entityId', entityId);
                    }

                    const signOnService = _.get(xmlObject, [
                        'EntityDescriptor',
                        'IDPSSODescriptor',
                        'SingleSignOnService',
                    ]);

                    if (signOnService) {
                        const [signInUrl] = signOnService
                            .filter((obj) => obj.Binding === 'urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST')
                            .map((obj) => obj.Location);

                        if (signInUrl) {
                            setFieldValue('signInUrl', signInUrl);
                        }
                    }

                    const logOutService = _.get(xmlObject, [
                        'EntityDescriptor',
                        'IDPSSODescriptor',
                        'SingleLogoutService',
                    ]);

                    if (logOutService) {
                        setFieldValue('logoutUrl', logOutService.Location);
                    }

                    const keyDescriptor = _.get(xmlObject, ['EntityDescriptor', 'IDPSSODescriptor', 'KeyDescriptor']);

                    if (keyDescriptor) {
                        const certificate = _.get(keyDescriptor, ['KeyInfo', 'X509Data', 'X509Certificate']);

                        if (certificate) {
                            setFieldValue('cert', certificate);
                        }
                    }

                    HelperFunctions.sleep(500).then(() => {
                        validateForm();
                    });
                }
            };

            reader.readAsText(file);
        }
    }
}

const style = {
    textAlign: 'center',
    marginBottom: '1rem',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
};
